// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b
import { TOP_IMAGES } from '../../assets/imgs';
import { ON_CHALLENGE } from '../constants';

export const convertSaleStatusToClassName = (status) => {
  let result = '';
  switch (status) {
    case 'NEW':
      result = TOP_IMAGES.LotteryStatus.NewLottery;
      break;
    case '販売予定':
      result = TOP_IMAGES.LotteryStatus.OnScheduleLottery;
      break;
    case '終了間近':
      result = TOP_IMAGES.LotteryStatus.NearEndSaleLottery;
      break;
    case '販売中':
      result = TOP_IMAGES.LotteryStatus.OnSaleLottery;
      break;
    default:
      result = TOP_IMAGES.LotteryStatus.EndSaleLottery;
      break;
  }
  return result;
};

export const convertSaleStatusToColor = (status) => {
  let result = '';
  switch (status) {
    case 'NEW':
      result = '#EB6566';
      break;
    case '販売予定':
      result = '#F49C17';
      break;
    case '終了間近':
      result = '#2F5A97';
      break;
    case '販売中':
      result = '#CE323A';
      break;
    default:
      result = '#939393';
      break;
  }
  return result;
};

export const convertRankName = (rankName) => {
  return rankName === ON_CHALLENGE ? '＋On Challenge' : rankName;
};
